import { ActionDispatching, StoreItemPath } from 'app/types-shared';
import { ComplexValue } from 'ui';
import { columnName, tableName } from 'app/area/case/case-data-model';
import { createUTCDate } from 'app/infrastructure/data/date';
import { actionCreators as draftActionCreators } from 'app/area/case/draft/actions';
import { getChildEntities } from 'app/infrastructure/store';
import { canAddEntry, readStoreField } from 'app/area/case/features/entry-log/helpers';

export const actionCreators = {     
  
  onAddInvolvedPersonEntry: (parentPath: StoreItemPath[], currentUser?: ComplexValue<number>): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {
      const entries = getChildEntities(getState().caseArea.editing?.values, parentPath, tableName.involvedPersonInConfinedSpace);
      if (!canAddEntry(entries, readStoreField)) {
        return { alreadyInside: true };
      }

      const log = columnName[tableName.involvedPersonInside];
      const initialValues: any = {
        [log.entryTime]: [{ value: createUTCDate() }],
        ...(currentUser && {
          [log.entryTimeRecordedBy]: [{ value: currentUser.value, description: currentUser.description }]
        })
      };

      await dispatch(draftActionCreators.addDocumentItem(parentPath, tableName.involvedPersonInConfinedSpace, false, { initialValues }));
      return { saved: true };
    },

  /**
   * Egresses an entry the same way the egress toggle button does:
   * sets egress time and who recorded it, then saves immediately.
   */
  onEgressInvolvedPersonEntry: (entryPath: StoreItemPath[], currentUser?: ComplexValue<number>): ActionDispatching<any, any> =>
    async (dispatch: any) => {
      const log = columnName[tableName.involvedPersonInside];
      const recordedBy = currentUser
        ? [{ value: currentUser.value, description: currentUser.description }]
        : [];

      // Dispatched together so no intermediate state has egressTime without egressTimeRecordedBy.
      await Promise.all([
        dispatch(draftActionCreators.valueChanged(entryPath, log.egressTime, [{ value: createUTCDate() }] as any)),
        dispatch(draftActionCreators.valueChanged(entryPath, log.egressTimeRecordedBy, recordedBy))
      ]);
      await dispatch(draftActionCreators.requestImmediateSave());
      return { saved: true };
    }
};
